export const helpPageURL = '/help/';
export const providerProfile = '/provider-profile/';
export const managementHub = '/management-hub/';

/**
 * Leaves an embedded web view for the apps' native hub, replacing the back stack
 * the web pages built rather than adding to it, so the hub is where "back" lands
 * next. `force` makes the hub re-read the current user, whose cached copy still
 * predates the sign-up that was just submitted.
 *
 * Keep in sync with `MANAGEMENT_HUB_RELAUNCH_DEEPLINK` in
 * `management_hub/constants.py`.
 */
export const managementHubRelaunchDeeplink =
  'rover://management-hub?force=true&navigation=popAndLaunch&rebuildBackstack=true';
export const trainerProfile = '/provider-profile/trainer-profile/';
export const providerProfilePayments = '/provider-profile/payment-methods/';
export const existingProviderSignUp = '/provider-profile/existing-provider-sign-up/';
export const availability = '/provider-profile/availability/';

// Legacy exports - kept for backward compatibility during migration
export const sitterProfile = '/provider-profile/details/';
export const dogCareDetails = '/provider-profile/details/dog-care-details/';
export const catCareDetails = '/provider-profile/details/cat-care-details/';
export const skills = '/provider-profile/details/skills/';
export const whatToExpect = '/provider-profile/details/what-to-expect/';
export const goals = '/provider-profile/goals';
export const goalsWorkSituation = `${goals}/work-situation`;
export const goalsMotivation = `${goals}/motivation`;
export const goalsRhythm = `${goals}/rhythm`;

export const servicePage = (serviceType: string): string =>
  serviceType !== '' ? `/provider-profile/services/${serviceType}/` : providerProfile;

const BASE_ROUTES = {
  details: '/provider-profile/details/',
  dogCareDetails: '/provider-profile/details/dog-care-details/',
  catCareDetails: '/provider-profile/details/cat-care-details/',
  skills: '/provider-profile/details/skills/',
  whatToExpect: '/provider-profile/details/what-to-expect/',
} as const;

const epsuBase = (slug: string) => `/provider-profile/existing-provider-sign-up/${slug}`;

export const buildRoutes = (serviceSlug?: string) => {
  if (serviceSlug) {
    const base = epsuBase(serviceSlug);
    return {
      details: `${base}/details/`,
      dogCareDetails: `${base}/details/dog-care-details/`,
      catCareDetails: `${base}/details/cat-care-details/`,
      skills: `${base}/details/skills/`,
      whatToExpect: `${base}/details/what-to-expect/`,
    };
  }
  return BASE_ROUTES;
};

export enum NavigationSource {
  ServiceForm = 'service-form',
  Skills = 'skills',
}
